export const isFrame = () => typeof window !== 'undefined' && self !== window.top;
